import { terminal } from "features/terminals/type";
import { UTILS } from "../../../utils/common";
import { transaction } from "../type";

function findLatestTransaction(transactions: transaction[]) {
  // Initialize with the first transaction
  let latestTransaction = transactions[0];

  // Iterate through the transactions
  for (let i = 1; i < transactions.length; i++) {
    // Convert string time to Date object for comparison
    const transactionTime = new Date(transactions[i].date_2);
    const latestTransactionTime = new Date(latestTransaction.date_2);

    // Compare times and update if the current transaction is later
    if (transactionTime > latestTransactionTime) {
      latestTransaction = transactions[i];
    }
  }

  return latestTransaction;
}
export const handleTransactions = (transactions?: transaction[]) => {
  if (transactions) {
    const transactionsGroup = UTILS.groupBy(
      transactions,
      "buyID"
    ) as transaction[][];
    return transactionsGroup.map((item) => {
      return {
        data: item,
        latest:
          item.find((obj) => obj.hidden === false) ||
          findLatestTransaction(item),
      };
    });
  }
};

export const terminalSelectOption = (data?: terminal[]) => {
  if (data) {
    return data.map((item) => {
      return { label: item.id, value: item.id };
    });
  } else {
    return undefined;
  }
};
